module.exports = __webpack_public_path__ + "static/img/recruit_tv-asahi_logo.e4cad8c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/recruit_2021/recruit_tv-asahi_logo.svg
// module id = OabH
// module chunks = 0